import React from "react";
import Image from "../../components/image";

import DownloadCTA from "../../components/shared/downloadCta";

const DownloadableGuide = ({
  guide,
  guideClass,
  guideTitleClass,
  guideContentWrapper
}) => {
  return (
    <section className={guideClass}>
      <div className="flex flex-col w-full justify-center md:w-4/5">
        <h2
          className={guideTitleClass}
          dangerouslySetInnerHTML={{
            __html: guide.sectionTitle ?? "Download our parent pack"
          }}
        />
        <div className={guideContentWrapper}>
          <div className="relative w-full md:w-1/2 sm:w-full left-info-wrapper h-auto sm:h-[420px]">
            <Image
              imageAlt=""
              image={""}
              imageClass="object-cover object-center w-full rounded-md h-full sm:h-[420px] rounded-b-none md:rounded-l-md md:rounded-r-none"
              sourceUrl={guide.imgUrl}
            />
          </div>
          <div className="flex flex-col items-start p-7 md:py-8 sm:px-8 w-full sm:w-1/2 gap-4 bg-white planet:bg-gray-darkest rounded-b h-auto sm:h-[420px]">
            <div className="w-full">
              <div
                className="text-black-lighter planet:text-white text-[26px] md:text-[2rem] font-light md:font-normal planet:font-light font-body md:font-alice planet:font-body leading-[34px] md:leading-[38px] py-4"
                dangerouslySetInnerHTML={{ __html: guide.title }}
              />
            </div>
            <div className={`sm:flex-1`}>
              <h6
                className="planet:text-gray-generic"
                dangerouslySetInnerHTML={{ __html: guide.subTitle }}
              />
            </div>
            <div className="md:block w-full sm:py-0">
              <div className="flex justify-between items-center">
                <div className="w-full md:w-7/12">
                  <DownloadCTA
                    to={guide.ctaLink}
                    ctaLabel={guide.ctaTitle}
                    type="ArrowDown"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

DownloadableGuide.defaultProps = {
  guideClass:
    "relative flex flex-col items-center justify-center px-4 py-10 mx-auto md:pt-20 md:pb-10 md:px-0 headinfo-section bg-white planet:bg-gray-dark",
  guideTitleClass:
    "w-full font-alice text-[26px] sm:text-[38px] planet:font-body",
  guideContentWrapper: "flex flex-col gap-10 md:flex-row sm:py-16"
};

export default DownloadableGuide;
